import * as React from 'react';
import {observer} from "mobx-react"
import '../index.css';
import '../../images/werkstatt_1.jpg';
import '../../images/werkstatt_2.jpg';
import '../../images/werkstatt_3.jpg';
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";



@observer
export default class Werkstatt extends React.Component {



    render()
    {

        return (
            <div>
                <div className="header_Verkauf">
                    <div className="header_openHours_text">Werkstätte</div>
                    <div className="header_openHours_body">Reperaturen aller Art</div>
                </div>
                <div className="textVerkauf">
                    In der bestens ausgestatteten, lichtdurchfluteten Fachwerkstätte mit Hallenkran, Montagegrube und moderner
                    Diagnosetechnik, bieten wir unseren Kunden Service, Reparaturen, Klimaservice, Montage uns Schlossereiarbeiten
                    an Landmaschinen, Traktoren und Transportern sowie Kleingeräten aller Marken, durch unsere
                    ausgebildeten Landmaschinentechniker. Pickerlüberprüfungen nach § 57 a für landwirtschaftliche oder
                    forstwirtschaftliche Zugmaschinen  (LoF ) , selbstfahrende Arbeitsmaschinen und Transporter bis 50km/h
                    gehören ebenfalls zu unseren Werkstattleistungen. 2 mobile Werkstattbusse sorgen stets für rasche Hilfe am Hof .
                    Ein firmeneigener LKW mit 10 m Kran kommt für die Montage von Heukrananlagen und der Zustellungen
                    von verkauften Fahrzeugen und Maschinen zum Einsatz.

                </div>
                <div className="wrapper">
                    <div className="root">
                        <GridList cellHeight={250}  spacing={30} cols={3} className="gridList_Werkstatt">
                            <GridListTile key={"1"}>
                                <div className="container container_no_padding">
                                    <img src="./images/werkstatt_1.jpg"
                                         alt="abc" className="imageFull"/>
                                </div>
                            </GridListTile>
                            <GridListTile key={"2"}>
                                <div className="container container_no_padding">
                                    <img src="./images/werkstatt_2.jpg"
                                         alt="abc" className="imageFull"/>
                                </div>
                            </GridListTile>
                            <GridListTile key={"3"}>
                                <div className="container container_no_padding">
                                    <img src="./images/werkstatt_3.jpg"
                                         alt="abc" className="imageFull"/>
                                </div>
                            </GridListTile>
                        </GridList>
                    </div>
                </div>
            </div>

        );

    }


}


